import { MenuItem, MenuItemProps } from '@reach/menu-button';
import React from 'react';

import './AccountMenuItem.scss';

type Props = MenuItemProps;

export const AccountMenuItem: React.FC<Props> = ({ children, ...props }) => {
  return (
    <MenuItem className="AccountMenuItem" {...props}>
      {children}
    </MenuItem>
  );
};
